import $ from 'jquery';

$('body').on('click', '.left-menu-title', function () {
    const $this = $(this);
    const leftMenu = $this.closest('.left-menu');
    leftMenu.toggleClass('left-menu--opened');
});
